import axios from "../api";

export const createKycPlanAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/kyc/plans", data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data || error));
  });
};

export const updateKycPlanAction = async (id, data) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/kyc/plans/update/${id}`, data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data || error));
  });
};

export const getKycPlanByIdAction = async (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/kyc/plans/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data || error));
  });
};

export const listAllKycPlansAction = (
  page,
  pageSize,
  searchValue = "",
  status = ""
) => {
  let apiUrl = `/api/kyc/plans?page=${page}&pageSize=${pageSize}`;

  if (searchValue) {
    apiUrl += `&searchValue=${searchValue}`;
  }

  if (status !== "" && status !== null) {
    apiUrl += `&status=${status}`;
  }

  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => resolve(response.data))
      .catch((error) =>
        reject(error.response?.data || error)
      );
  });
};

export const listAllKycPlansDropDownAction = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/kyc/plans/plan-dropdown")
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data || error));
  });
};

export const deleteMultipleKycPlansAction = async (ids) => {
  return new Promise((resolve, reject) => {
    axios
      .put("/api/kyc/plans/deleteMultiple", ids)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const updateKycPlanStatusAction = async (id, data) => {
    return new Promise((resolve, reject) => {
        axios
            .put(`/api/kyc/plans/update-plan-status/${id}`, data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error.response?.data || error);
            });
    });
};

export const listCountriesAction = async (page, limit, search, code, name) => {
    let apiUrl = `/api/kyc/countries?page=${page}&limit=${limit}`;

    if (search) {
        apiUrl += `&search=${search}`;
    }

    if (code) {
        apiUrl += `&code=${code}`;
    }

    if (name) {
        apiUrl += `&name=${name}`;
    }

    return new Promise((resolve, reject) => {
        axios
            .get(apiUrl)
            .then((response) => resolve(response.data))
            .catch((error) => reject(error.response?.data || error));
    });
};